import { Component, forwardRef, HostListener, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const defaultBorderStyle = 'none';

@Component({
  selector: 'app-smash-input-message',
  templateUrl: './smash-input-message.component.html',
  styleUrls: ['./smash-input-message.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmashInputMessageComponent),
      multi: true
    }
  ]
})
export class SmashInputMessageComponent {

  /* Border classes for input */
  inputBorderClasses = {
    none: '',
    full: 'border-full',
  }

  /* Input is focused or not */
  inputFocused = false;
  wasInside = false;

  constructor() { }

  @Input() error: boolean;

  @Input('value') _value: any;
  @Input('placeholder') placeholder: string = "";
  @Input() borderStyle: string = defaultBorderStyle;

  get value() {
    return this._value;
  }

  onChange: any = () => { };
  onTouch: any = () => { };
  val = "";

  set value(val) {
    if (val !== undefined && this.val !== val) {
      this._value = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  /* Handling focus */
  @HostListener('click')
  clickInside() {
    this.inputFocused = true;
  }

  onClickOutside() {
    this.inputFocused = false;
  }
}
